// import { Router } from "@angular/router";
// import { environment } from "src/environments/environment";

import { Subject } from "rxjs";


export class AppCommon {
    
   
    constructor() { }

    static getloggedInObject() {
        return JSON.parse(localStorage.getItem("loggedInUserInsight360")) || undefined;
    }
     
    

    // to get status of logged in user
    static isLoggedIn() {
        if (
            this.getloggedInObject() != undefined &&
            this.getloggedInObject() != null
             &&
            this.getloggedInObject().token != undefined &&
            this.getloggedInObject().token != ""
        ) {
            return true;
        } else {
            return false;
        }
    }

    static clearStorage(){
        localStorage.clear();
    }

    static setLoggedInObject(e: any){
        localStorage.setItem("loggedInUserInsight360", JSON.stringify(e));
    } 

 
    
    static getDicebearIcon(firstLetter: string){
        return 'https://api.dicebear.com/6.x/initials/svg?seed=' + firstLetter.toUpperCase()
    }
    
}